import React from 'react';

const ErrorAlert = ({ message, onClose }) => {
  return (
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      <div className="d-flex align-items-center">
        <i className="bi bi-exclamation-triangle me-2"></i>
        <span>{message || 'An error occurred. Please try again.'}</span>
      </div>
      {onClose && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      )}
    </div>
  );
};

export default ErrorAlert;
